import { fiscalDocumentKindOptions } from '@/features/privateCompanies/constants/fiscalDocumentKind.constant'
import { GeoTransformers } from '@/common/services/geoTransformers'
import { dateIsoTransformer } from '@/common/utils/dateTransformer'
import { options as governmentSegmentOptions } from '@/features/publicCompanyLeadsFunnel/constants/governmentSegmentOptions.constant'
import {
  PublicCompanyLeadsFunnelUpdateValidationSchema,
  updateSchema,
} from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { PublicCompanyLeadData } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

const usePublicCompanyLeadForm = ({ publicCompanyLead }: { publicCompanyLead: PublicCompanyLeadData }) => {
  return useForm<PublicCompanyLeadsFunnelUpdateValidationSchema>({
    resolver: zodResolver(updateSchema),
    defaultValues: {
      commercial_manager: publicCompanyLead?.commercial_manager ? {
        label: publicCompanyLead?.commercial_manager.full_name,
        value: publicCompanyLead?.commercial_manager.id,
      } : undefined,
      commercial_manager_substitute: publicCompanyLead?.commercial_manager_substitute ? {
        label: publicCompanyLead?.commercial_manager_substitute.full_name,
        value: publicCompanyLead?.commercial_manager_substitute.id,
      } : undefined,
      bidding_information: {
        contest_date: publicCompanyLead?.bidding_information?.contest_date
          ? dateIsoTransformer(publicCompanyLead?.bidding_information.contest_date)
          : '',
        object_of_the_bidding: publicCompanyLead?.bidding_information?.object_of_the_bidding || undefined,
        government_segment: governmentSegmentOptions.find(
          ({ value }) => value === publicCompanyLead?.bidding_information?.government_segment,
        ),
        notice_number: publicCompanyLead?.bidding_information?.notice_number || undefined,
        geo_geoables: publicCompanyLead?.bidding_information?.government_segment
          ? GeoTransformers.mapToGeo()(publicCompanyLead?.bidding_information?.geo_geoables)
          : undefined,
        minimum_establishments_in_region: publicCompanyLead?.bidding_information?.minimum_establishments_in_region
          ? `${publicCompanyLead?.bidding_information?.minimum_establishments_in_region}`
          : undefined,
      },
      general_information: {
        ...publicCompanyLead?.general_information,
      },
      address_attributes: {
        ...publicCompanyLead?.address,
      },
      fiscal_document_information: {
        ...publicCompanyLead?.fiscal_document_information,
        fiscal_document_kind: fiscalDocumentKindOptions.find(({ value }) => value === publicCompanyLead.fiscal_document_information?.fiscal_document_kind),
      },
    },
  })
}

export default usePublicCompanyLeadForm
